import { styled } from "@linaria/react";
import React from "react";
import type { UserProject } from "../../../api/useUsers";
import t from "../../../i18n";
import { color, easingBounce, easingBounceMs, radius, fonts } from "@ui";
import LinkMemo from "@ui/Link";
import Menu from "@ui/Menu";
import type { UserProjectRoleOption } from "./ProjectRolesOptions";
import ProjectRolesOptions from "./ProjectRolesOptions";
import type { ProjectRole } from "../../../api/useUser";

const StyledMenu = styled(Menu)`
  font: ${fonts.body2SemiBold};
`;

const SelectLink = styled(LinkMemo)`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  color: ${color.carbon900};
  font: ${fonts.body1};
  padding: 8px;
  border-radius: ${radius};
  min-width: 80px;
  flex-shrink: 0;

  :hover {
    background-color: ${color.titanium100};
  }
  &.opened {
    box-shadow: inset 0 0 0 1px ${color.titanium100};
  }
  ::after {
    margin-left: 10px;
    display: inline-block;
    content: "";
    width: 0.55em;
    height: 0.55em;
    border-top: 1px solid currentColor;
    border-right: 1px solid currentColor;
    transition: transform ${easingBounceMs}ms ${easingBounce};
    transform: rotate(135deg);
    transform-origin: 65% 35%;
    margin-right: 0.3em;
  }
  &.opened::after {
    transform: rotate(315deg);
  }
`;

export function getProjectRoleName(role: ProjectRole | null) {
  if (role === null) return t("users.selectFilter.none");

  const roleLabels: string[] = [];
  const isAdmin = role.includes("MANAGER");
  const isReader = role.includes("READER");
  const isWritter = role.includes("WRITER");
  const isSetuper = role.includes("SETUPER");

  if (isReader) roleLabels.push(t("users.selectFilter.project_reader"));
  else if (isWritter) roleLabels.push(t("users.selectFilter.project_writer"));
  else if (isSetuper) roleLabels.push(t("users.selectFilter.project_setuper"));

  if (isAdmin) roleLabels.push(t("users.selectFilter.project_admin"));

  return roleLabels.join(", ");
}
interface RoleOption {
  titleLabel: string;
  descriptionLabel: string;
  value: Exclude<UserProjectRoleOption, null>;
  disabled?: boolean;
}
interface P {
  project: UserProject;
  options: RoleOption[];
  onRoleClick: (role: UserProjectRoleOption) => void;
}

function ProjectRoleMenu({ project, options, onRoleClick }: P) {
  const label = getProjectRoleName(project.role);
  const projetRole = project.role;
  return (
    <StyledMenu
      placement="bottom"
      arrowWidth={0}
      overlay={
        <ProjectRolesOptions
          options={options}
          currentSelection={projetRole}
          onClick={onRoleClick}
        />
      }
    >
      <SelectLink>{label ? label : t("users.table.row.menu.roles.no_role")}</SelectLink>
    </StyledMenu>
  );
}

export default ProjectRoleMenu;
